import { connect } from 'react-redux'
import ProductListViewMyStoreWithVolumeDiscount from './ProductListViewMyStoreWithVolumeDiscount'
import { getState, getDispatch } from 'x/modules/productlist/ProductListViewConnect'

export default connect(
  (state) => getState(state),
  (dispatch) => getDispatch(dispatch)
)(ProductListViewMyStoreWithVolumeDiscount)
